import { CircleHalfIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Comparison = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <CircleHalfIcon color={fill} {...rest} size={Sizes[size]} />;
};

Comparison.displayName = 'Comparison';
